import type {
  DepositCollectionPoint,
  DepositRefundPoint,
  PaymentKind,
  PaymentMethod,
} from '../generated/enums';

/**
 * What a payment was for and how it moved, in the counter's words — on the phone's screens and on
 * the printed receipt, so the paper a customer takes home says what the screen said.
 *
 * <p>
 * Keyed by the generated enums, so a kind added on the server is a compile error here until it has
 * words; `paymentWords.test.ts` is the second guard, since `''` satisfies the type and prints
 * nothing.
 * </p>
 */
export const paymentKindLabel: Record<PaymentKind, string> = {
  Token: 'Token',
  RentalBalance: 'Rental balance',
  Deposit: 'Security deposit',
  DepositRefund: 'Deposit refund',
  LateFee: 'Late fee',
  DamageCharge: 'Damage',
  MissingAccessory: 'Missing accessory',
  AlterationCharge: 'Alteration',
  CancellationFee: 'Cancellation fee',
  RentalRefund: 'Rent given back',
};

export const paymentMethodLabel: Record<PaymentMethod, string> = {
  Cash: 'Cash',
  Upi: 'UPI',
  Card: 'Card',
  BankTransfer: 'Bank transfer',
  Cheque: 'Cheque',
  Adjustment: 'Adjustment',
};

/** When the deposit goes back — the return counter's words. */
export const refundPointLabel: Record<DepositRefundPoint, string> = {
  AtCounter: 'Now, at the counter',
  AfterInspection: 'After inspection',
  AfterCleaning: 'After cleaning',
};

/** When the deposit is taken. */
export const collectionPointLabel: Record<DepositCollectionPoint, string> = {
  AtBooking: 'At booking',
  AtPickup: 'At pickup',
  Split: 'Half and half',
};
